import type { FLAG } from '@shared/products-types';
import type { ProductWithHelpers } from '@shared/products-core';
import { getFeatureConfig } from '@luna/feature-config';

export const isAliasChangeAllowed = ({ flags = [], underlyingData }: ProductWithHelpers) => {
    const { isJuniorAliasChangeAllowed } = getFeatureConfig(({ accounts }) => accounts);

    return (
        !(
            flags.includes('junior') ||
            (underlyingData as { flags?: FLAG })?.flags?.includes('junior')
        ) || isJuniorAliasChangeAllowed
    );
};
